export default function EditTrainingWebinarDirective() {
  return {
    template: require('./edit-webinar.directive.html'),
    scope: {
      newMediaInputs: '=',
      topic: '=',
      section: '=',
      media: '=',
    },
    controller: 'EditTrainingWebinarDirectiveController',
    controllerAs: 'editTrainingWebinarVM',
    bindToController: true,
    replace: true,
  };
}
